if (!customElements.get('read-more')) {
  customElements.define(
    'read-more',
    class ReadMore extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          content: '.read-more__content',
          button: '.read-more__toggle',
          buttonText: '.button-text',
        };

        this.classes = {
          isDisabled: 'is-disabled',
          isCollapsed: 'is-collapsed',
        };

        this.abortController = new AbortController();

        this.toggleClass = this.dataset.toggleClass;
        this.showText = this.dataset.showText;
        this.hideText = this.dataset.hideText;
        this.buttonEl = this.querySelector(this.selectors.button);
        this.contentEl = this.querySelector(this.selectors.content);

        this.buttonEl.addEventListener('click', this.onClick.bind(this), {
          signal: this.abortController.signal,
        });

        
        const mql = window.matchMedia('screen and (max-width: 767px)');
        mql.onchange = (e) => {
          this.init(e.matches);
        };

        this.init(mql.matches);
      }

      init (isMobile) {
        if (isMobile) {
          this.classList.remove(this.classes.isDisabled);
          this.contentEl.classList.remove(this.toggleClass);
          this.showLess();
        } else {
          this.classList.add(this.classes.isDisabled);
          this.contentEl.classList.add(this.toggleClass);
          this.showMore();
        }
      }

      showMore() {
        this.contentEl.classList.remove(this.toggleClass);
        this.classList.remove(this.classes.isCollapsed);
        this.buttonEl.querySelector(this.selectors.buttonText).textContent = this.hideText;
      }

      showLess() {
        this.contentEl.classList.add(this.toggleClass);
        this.classList.add(this.classes.isCollapsed);
        this.buttonEl.querySelector(this.selectors.buttonText).textContent = this.showText;
      }

      onClick(evt) {
        if (this.contentEl.classList.contains(this.toggleClass)) {
          this.showMore();
        } else {
          this.showLess();
        }
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }
  );
}
